import { teamCodeHashInput } from '@treetrack/protocol';

function subtle(): SubtleCrypto {
  const c = globalThis.crypto;
  if (!c?.subtle) throw new Error('WebCrypto is not available');
  return c.subtle;
}

/** SHA-256 of a UTF-8 string as lower-case hex. */
export async function sha256Hex(text: string): Promise<string> {
  const buf = await subtle().digest('SHA-256', new TextEncoder().encode(text));
  return Array.from(new Uint8Array(buf), (b) => b.toString(16).padStart(2, '0')).join('');
}

/** What goes in teams.code_hash; must equal team_code_hash(project_id, code) in SQL. */
export function teamCodeHash(projectId: string, code: string): Promise<string> {
  return sha256Hex(teamCodeHashInput(projectId, code));
}

export function randomBytes(n: number): Uint8Array {
  const out = new Uint8Array(n);
  globalThis.crypto.getRandomValues(out);
  return out;
}
